<template>
  <section
    class="teacher-signup signup"
    :style="{
      'background-image':
        'url(' + bucketUrl + '/assets/background_landing-page.jpg)'
    }"
  >
    <header-logged-out type="teacher" :checkuser="false" />
    <v-container fill-height>
      <v-row no-gutters align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="11" xl="5">
          <v-expand-transition>
            <v-card style="transition: 2s linear 1s;">
              <v-toolbar dark color="primary" flat>
                <v-toolbar-title>Got it!</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <div>
                  Your support query has been submitted and someone from our
                  team will endeavour to contact you within 2 business days.
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                </div>
              </v-card-text>
              <v-card-actions class="px-3 pb-3 pt-0">
                <div>
                  Already have an account?
                  <router-link to="/teacher/login" style="color: #1565c0">
                    Click here to log in.
                  </router-link>
                </div>
                <v-spacer />
              </v-card-actions>
            </v-card>
          </v-expand-transition>
        </v-col>
      </v-row>
      <custom-snackbar />
    </v-container>
  </section>
</template>

<script>
import { _constants } from 'crypto'
import { mapMutations, mapState } from 'vuex'
import CustomSnackbar from '@/components/snackbar/snackbar'
import HeaderLoggedOut from '@/modules/auth/views/HeaderLoggedOut'
import Config from '@/modules/config/models/Config'

export default {
  name: 'SupportMessageConfirmation',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    CustomSnackbar,
    HeaderLoggedOut
  },
  computed: {
    ...mapState(['bucketUrl']),
    title() {
      return Config.value('title')
    }
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar', 'showErrorSnackbar'])
  }
}
</script>

<style lang="scss">
.teacher-signup {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
}
</style>
